const travelServiceOrderItemPartFactory = type => {
  let formPart;
  if (type === "flight") {
    formPart = {
      carrier: null,
      start_date: null,
      end_date: null,
      start_place: null,
      end_place: null,
      seat_class: null,
      baggage: null,
      flight_number: null,
      comment: null,
      is_return_route: false
    };
  } else if (type === "low-cost") {
    formPart = {
      carrier: null,
      start_date: null,
      end_date: null,
      start_place: null,
      end_place: null,
      seat_class: "Tanie linie lotnicze",
      baggage: null,
      flight_number: null,
      comment: null,
      is_return_route: false
    };
  } else if (type === "car") {
    formPart = {
      start_date: null,
      end_date: null,
      from: null,
      to: null,
      name: null,
      car_class: null,
      price_per_day: null,
      comment: null
    };
  } else if (type === "hotel") {
    formPart = {
      hotel_class: null,
      name: null,
      address: null,
      start_date: null,
      end_date: null,
      rooms: "1",
      person_per_room: "1",
      room_type: "Standard",
      additional_services: null,
      cancel_until: null,
      price_per_day: null,
      comment: null
    };
  } else if (type === "rail") {
    formPart = {
      start_date: null,
      from: null,
      end_date: null,
      to: null,
      seat_class: null,
      carrier: null,
      comment: null,
      is_return_route: false
    };
  }
  return formPart;
};

export default travelServiceOrderItemPartFactory;
